module.exports = __webpack_public_path__ + "static/img/6.502213e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/zh/6.png
// module id = 0eyi
// module chunks = 0